import styled from 'styled-components';
import {
  Title as _Title, SubTitle as _SubTitle
} from '../styled';

export const SubTitle = styled(_SubTitle)`
    margin-bottom: 23px;
`;

export const Title = styled(_Title)`
    margin-bottom: 21px;
`;

export const Code = styled.code`
  font-size: 11px;
  line-height: 1.42;
  color: #1c2243;
  word-break: break-all;
`;

export const CodeWrapper = styled.div`
  background:#edf2f7;
  border: solid 1px #bec8d2;
  width: 395px;
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 21px;
  margin-right: 20px;
`;

export const Link = styled.a`
  text-decoration:none;
  font-size: 13.5px;
  cursor: pointer;
  color: #007bff;
  &:link,
  &:visited,
  &:hover,
  &:active {
    color: #007bff;
    text-decoration: none;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 21px;
`;
